/* dl-home.js — "Překvapte mě" + rozpočet. Both the plain button and the budget chips
   fetch sections/dl-surprise.liquid via the Section Rendering API, so every roll draws
   from the whole pool collection. No backslashes: the deploy path rejects escapes. */
(function () {
  var rail = document.getElementById('dl-brail');
  var btn = document.getElementById('surprise');
  if (!rail || !btn) return;
  var bud = document.getElementById('dl-budget');
  var note = document.getElementById('dl-bnote');
  var sec = btn.closest ? btn.closest('.sec') : null;
  var kick = sec ? sec.querySelector('.k') : null;
  var HANDLE = bud ? (bud.getAttribute('data-pool') || '') : '';
  var ROOT = (bud && bud.getAttribute('data-root')) || '/';
  var OVER = bud ? (parseFloat(bud.getAttribute('data-over')) || 0) : 0;
  var ORIG = rail.innerHTML, KICK0 = kick ? kick.textContent : '';
  var TILES = rail.children.length || 8;
  var cache = {}, budget = 0, busy = false, wipe = null;
  function shuffle(l) {
    var a = l.slice(), i, j, t;
    for (i = a.length - 1; i > 0; i--) { j = Math.floor(Math.random() * (i + 1)); t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function cap() { return budget ? Math.round(budget * (1 + OVER / 100)) : 0; }
  function czk(n) {
    var s = String(n), o = '', i;
    for (i = 0; i < s.length; i++) { if (i > 0 && (s.length - i) % 3 === 0) o += ' '; o += s.charAt(i); }
    return o + ' Kč';
  }
  function plural(n) { return n === 1 ? 'svítidlo' : (n >= 2 && n <= 4 ? 'svítidla' : 'svítidel'); }
  function say(m) { if (note) note.textContent = m || ''; }
  function kicker(t) { if (kick) kick.textContent = t; }
  function label(b) {
    var c = bud && bud.querySelector('.bchip[data-b="' + b + '"]');
    return c ? c.textContent.trim() : ('do ' + czk(b));
  }
  function url(c, page) {
    var base = ROOT;
    while (base.length > 1 && base.charAt(base.length - 1) === '/') base = base.slice(0, -1);
    if (base === '/') base = '';
    var u = base + '/collections/' + HANDLE + '?section_id=dl-surprise';
    if (c) u += '&filter.v.price.lte=' + c;
    if (page > 1) u += '&page=' + page;
    return u;
  }
  function grab(c, page) {
    return fetch(url(c, page)).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var box = document.createElement('div');
      box.innerHTML = html;
      var w = box.querySelector('#dlsp'), items = [];
      if (!w) throw new Error('no wrapper');
      [].forEach.call(w.querySelectorAll('.dlsp-i'), function (n) {
        var a = n.querySelector('.pcard');
        if (a) items.push({ html: a.outerHTML, price: parseInt(n.getAttribute('data-p'), 10) || 0 });
      });
      return { count: parseInt(w.getAttribute('data-count'), 10) || 0,
               pages: parseInt(w.getAttribute('data-pages'), 10) || 1, items: items };
    });
  }
  function merge(st, res, page) {
    st.seen[page] = 1; st.count = res.count; st.pages = res.pages;
    var have = {};
    st.items.forEach(function (i) { have[i.html] = 1; });
    res.items.forEach(function (i) { if (!have[i.html]) { have[i.html] = 1; st.items.push(i); } });
  }
  function unseen(st) {
    var free = [], p;
    for (p = 1; p <= st.pages; p++) if (!st.seen[p]) free.push(p);
    return free.length ? free[Math.floor(Math.random() * free.length)] : 0;
  }
  function pool() {
    var c = cap(), st = cache[c], keep = function () { return st; };
    if (!st) {
      st = cache[c] = { count: 0, pages: 1, seen: {}, items: [] };
      return grab(c, 1).then(function (res) {
        merge(st, res, 1);
        var p = unseen(st);
        if (!p) return st;
        return grab(c, p).then(function (r2) { merge(st, r2, p); return st; }, keep);
      });
    }
    var n = unseen(st);
    if (!n) return Promise.resolve(st);
    return grab(c, n).then(function (res) { merge(st, res, n); return st; }, keep);
  }
  function paint(list) {
    if (!list.length) return;
    clearTimeout(wipe);
    rail.classList.add('busy');
    setTimeout(function () {
      rail.innerHTML = list.join('');
      var kids = [].slice.call(rail.children);
      kids.forEach(function (c, i) { c.style.opacity = '0'; c.style.transition = 'opacity .22s ease ' + (i * 45) + 'ms'; });
      rail.classList.remove('busy');
      requestAnimationFrame(function () { kids.forEach(function (c) { c.style.opacity = '1'; }); });
      wipe = setTimeout(function () { kids.forEach(function (c) { c.style.opacity = ''; c.style.transition = ''; }); }, kids.length * 45 + 400);
      if (rail.scrollTo) rail.scrollTo({ left: 0, behavior: 'smooth' }); else rail.scrollLeft = 0;
    }, 170);
  }
  function reset() {
    budget = 0; clearTimeout(wipe); rail.classList.remove('busy');
    rail.innerHTML = ORIG; kicker(KICK0); say('');
  }
  function roll() {
    if (busy || !HANDLE) return;
    busy = true; btn.disabled = true;
    var ceil = cap() * 100;
    var done = function () { busy = false; btn.disabled = false; };
    pool().then(function (st) {
      done();
      var ok = ceil ? st.items.filter(function (i) { return i.price > 0 && i.price <= ceil; }) : st.items;
      if (!ok.length) { say('V rozpočtu „' + label(budget) + '“ teď nic nemáme.'); return; }
      paint(shuffle(ok).slice(0, TILES).map(function (i) { return i.html; }));
      kicker(budget ? ('náhodný objev · ' + label(budget)) : 'náhodný objev');
      say(st.count && st.count <= TILES * 2 ? ('máme jen ' + st.count + ' ' + plural(st.count)) : '');
    }, function () { done(); say('Výběr se nepodařilo načíst, zkuste to prosím znovu.'); });
  }
  btn.addEventListener('click', roll);
  if (bud) {
    var chips = [].slice.call(bud.querySelectorAll('.bchip'));
    var custom = document.getElementById('dl-bcustom');
    var clear = function () {
      chips.forEach(function (c) { c.classList.remove('on'); c.setAttribute('aria-pressed', 'false'); });
    };
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = parseInt(chip.getAttribute('data-b'), 10) || 0;
        clear(); chip.classList.add('on'); chip.setAttribute('aria-pressed', 'true');
        if (custom) custom.value = '';
        budget = v;
        if (!v) reset(); else roll();
      });
    });
    if (custom) {
      var apply = function () {
        var v = parseInt(custom.value, 10);
        if (!v || v <= 0) return;
        clear(); budget = v; roll();
      };
      custom.addEventListener('change', apply);
      custom.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); apply(); }
      });
    }
  }
})();